var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FormControl, FormErrorMessage, FormHelperText, FormLabel, Tooltip } from '@chakra-ui/react';
const layoutDisplay = {
    vertical: 'block',
    horizontal: 'flex',
    inline: 'inline-block',
};
// TODO: [6h]栅格模式 [4h]layout-inline [4h]label溢出处理
export const FormItem = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const { label, layoutStyle = {}, layout = 'horizontal', colon = true, addonBefore, 
    // addonAfter,
    asterisk, extra, feedbackStatus, feedbackText, 
    // fullness,
    // feedbackLayout,
    // feedbackIcon,
    // inset,
    // bordered = true,
    labelWidth, wrapperWidth, 
    // labelCol,
    // wrapperCol,
    labelAlign = 'right', wrapperAlign = 'left', size = 'md', 
    // labelWrap,
    // wrapperWrap,
    tooltipLayout, tooltip, labelStyle = {}, wrapperStyle = {}, gridSpan, } = props;
    // 固定宽度
    if (labelWidth || wrapperWidth) {
        if (labelWidth) {
            labelStyle.width = labelWidth === 'auto' ? undefined : labelWidth;
            labelStyle.maxWidth = labelWidth === 'auto' ? undefined : labelWidth;
            labelStyle.textAlign = labelAlign;
        }
        if (wrapperWidth) {
            wrapperStyle.width = wrapperWidth === 'auto' ? undefined : wrapperWidth;
            wrapperStyle.maxWidth = wrapperWidth === 'auto' ? undefined : wrapperWidth;
            wrapperStyle.textAlign = wrapperAlign;
        }
    }
    if (layout === 'inline') {
        labelStyle.display = 'inline-block';
        wrapperStyle.display = 'inline-block';
        wrapperStyle.width = 'initial';
    }
    else {
        wrapperStyle.width = '100%';
    }
    const gridStyles = {};
    if (gridSpan) {
        gridStyles.gridColumnStart = `span ${gridSpan}`;
    }
    const renderLabelText = () => {
        const labelChildren = (_jsxs(Box, Object.assign({ as: "span", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, { children: [asterisk && (_jsx(Box, Object.assign({ as: "span", mr: "1", color: "red.500" }, { children: '*' }))), _jsx("label", { children: label })] })));
        if (tooltipLayout === 'text' && tooltip) {
            return (_jsx(Tooltip, Object.assign({ hasArrow: true, placement: "top", offset: [0, 10], label: tooltip }, { children: labelChildren })));
        }
        return labelChildren;
    };
    const isInvalid = feedbackStatus === 'warning' || feedbackStatus === 'error';
    const { marginBottom = layout === 'vertical' ? 3 : 6 } = layoutStyle;
    return (_jsxs(FormControl, Object.assign({ "data-span": gridSpan || 1, isInvalid: isInvalid, width: "initial", position: "relative", display: layoutDisplay[layout], _notLast: {
            mb: marginBottom,
        } }, layoutStyle, gridStyles, { children: [Boolean(label) && (_jsxs(FormLabel, Object.assign({ size: size }, labelStyle, { children: [renderLabelText(), _jsx(Box, Object.assign({ as: "span", mx: "0.5" }, { children: colon ? ':' : '' })), addonBefore && (_jsx(Box, Object.assign({ as: "span", color: "gray.500", fontWeight: "normal" }, { children: addonBefore })))] }))), _jsxs(Box, Object.assign({ style: wrapperStyle }, { children: [children, isInvalid ? _jsx(FormErrorMessage, { children: feedbackText }) : _jsx(FormHelperText, { children: extra })] }))] })));
};
